import classNames from "classnames";
import { get } from "lodash";
import { MdDraw } from "react-icons/md";
import Button from "shared/components/Button";
import Popover from "shared/components/Popover";
import { CURRENCY_SYMBOL } from "utils/constants";
import { computeUpsellPricing } from "utils/helpers/lumineisUpsells";
import { costToFrench } from "utils/helpers/values";
import Upsells from "../Upsells";

const Card = ({
  cost,
  currency = "DEFAULT",
  insurancePlan,
  period,
  action,
  popover = {},
  selectedModules = [],
  setSelectedModules,
  translation,
  project,
}) => {
  const selected = get(selectedModules, insurancePlan.id, []);
  const { total: upsellsTotal } = computeUpsellPricing({
    modules: selected,
    selectedModules: selected,
  });
  const formatted = costToFrench(cost + upsellsTotal, 2);
  const [integer, decimal = "00"] = String(formatted || "-").split(",");
  const symbol = CURRENCY_SYMBOL[currency];
  return (
    <div className="insurance-plan">
      {insurancePlan.icon && (
        <img
          className="insurance-plan__icon"
          src={insurancePlan.icon}
          alt={insurancePlan.name}
        />
      )}
      <div className="insurance-plan__title">
        {insurancePlan.name}
        <div
          className={classNames("insurance-plan__title--light", {
            hidden: !insurancePlan.description,
          })}
        >
          {insurancePlan.description || "-"}
        </div>
      </div>
      <div className="insurance-plan__bottom">
        <div className="insurance-plan__cost">
          <span className="insurance-plan__cost--integer">
            {`${integer} ${symbol} `}
            <span className="insurance-plan__cost--decimal">{`${decimal}`}</span>
          </span>
          <span className="insurance-plan__cost--period">{` /${period}`}</span>
        </div>
        <Upsells
          insurancePlan={insurancePlan}
          cost={cost}
          currency={currency}
          selectedModules={selectedModules}
          setSelectedModules={setSelectedModules}
          disabled={!action.disabled}
          translation={translation}
          project={project}
        />
        <div className="popover-wrapper">
          {popover.active && <Popover text={popover.text} />}
          <Button
            type="secondary"
            onClick={action.onClick}
            disabled={!!action.disabled || !!action.loading}
            loading={!!action.loading}
          >
            {action.label}
            {!action.loading && <MdDraw size={16} />}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Card;
